import { __spreadArray, __read } from 'tslib';
import useAutoRunPlugin from './plugins/useAutoRunPlugin.js';
import useCachePlugin from './plugins/useCachePlugin.js';
import useDebouncePlugin from './plugins/useDebouncePlugin.js';
import useLoadingDelayPlugin from './plugins/useLoadingDelayPlugin.js';
import usePollingPlugin from './plugins/usePollingPlugin.js';
import useRefreshOnWindowFocusPlugin from './plugins/useRefreshOnWindowFocusPlugin.js';
import useRetryPlugin from './plugins/useRetryPlugin.js';
import useThrottlePlugin from './plugins/useThrottlePlugin.js';
import useRequestImplement from './useRequestImplement.js';

// function useRequest<TData, TParams extends any[], TFormated, TTFormated extends TFormated = any>(
//   service: Service<TData, TParams>,
//   options: OptionsWithFormat<TData, TParams, TFormated, TTFormated>,
//   plugins?: Plugin<TData, TParams>[],
// ): Result<TFormated, TParams>
// function useRequest<TData, TParams extends any[]>(
//   service: Service<TData, TParams>,
//   options?: OptionsWithoutFormat<TData, TParams>,
//   plugins?: Plugin<TData, TParams>[],
// ): Result<TData, TParams>
function useRequest(service, options, plugins) {
  return useRequestImplement(service, options, __spreadArray(__spreadArray([], __read(plugins || []), false), [useDebouncePlugin, useLoadingDelayPlugin, usePollingPlugin, useRefreshOnWindowFocusPlugin, useThrottlePlugin, useAutoRunPlugin, useCachePlugin, useRetryPlugin], false));
}

export { useRequest as default };
